import { useGetAllCourtsQuery } from '../../Api/courts';
import CourtCard from '../../Components/CourtCard';
import HomepageWrapper from './style/homepageWrapper';
import Wallpaper from './Wallpaper';

const HomePage = () => {
  const { data: courtsData, isSuccess } = useGetAllCourtsQuery();

  return (
    <HomepageWrapper>
      <Wallpaper />
      <section className='cards-container'>
        {isSuccess
          ? courtsData?.map((item) => (
              <CourtCard data={item} colAmount={courtsData.length} key={item.id} />
            ))
          : null}
      </section>
    </HomepageWrapper>
  );
};

export default HomePage;
